import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=570fdfea&scoped=true&"
import script from "./menu-list.vue?vue&type=script&lang=js&"
export * from "./menu-list.vue?vue&type=script&lang=js&"
import style0 from "./menu-list.vue?vue&type=style&index=0&id=570fdfea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570fdfea",
  null
  
)

export default component.exports